import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function logout(userId: number) {
  const response = await http
    .getDataParam(`/logout`, { user_id: userId })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getMe() {
  const response = await http.getData(`/users/me`).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

async function changePassword(oldPassword, newPassword) {
  const response = await http
    .putData(`/users/password`, {
      old_password: oldPassword,
      new_password: newPassword
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function statelessChangePassword(params: {
  username: string;
  email: string;
  old_password: string;
  new_password: string;
}) {
  const response = await http
    .putData(`/stateless-user-password`, params)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function changePinTtd(oldPassword, newPassword) {
  const response = await http
    .putData(`/users/pin-ttd`, {
      old_password: oldPassword,
      new_password: newPassword
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function resetPinTtd(params: { email: string; password: string }) {
  const response = await http
    .postData(`/users/forget-pin-ttd`, params)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getAnnouncement(userId: number) {
  const response = await http
    .getData(`/user/${userId}/announcement`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function setAnnouncementConfirmed(userId: number, ancIds: number[]) {
  const response = await http
    .postData(`/user/${userId}/announcement/confirmed`, {
      announcement: ancIds
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

export default {
  logout,
  getMe,
  changePassword,
  changePinTtd,
  statelessChangePassword,
  resetPinTtd,
  getAnnouncement,
  setAnnouncementConfirmed
};
